/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
import { colors } from "../../theme";

const containerStyle = spacing => css`
    display: flex;
    flex-direction: column;
    align-items: start;
    margin: auto;
    padding: 0 20px;
    max-width: 480px;
    @media (max-width: 520px) {
        min-height: 90%;
    }
    & > * {
        margin-top: ${spacing}px;
    }
    & h1 {
        align-self: center;
        color: ${colors.neutral8};
        font-family: Montserrat;
        font-weight: 800;
        font-size: 44px;
        line-height: 56px;
        @media (max-width: 520px) {
            font-size: 24px;
            line-height: 32px;
        }
    }
    & h2 {
        font-family: Montserrat;
        font-weight: 800;
        font-size: 36px;
        line-height: 40px;
        @media (max-width: 520px) {
            font-size: 21px;
            line-height: 24px;
        }
        color: ${colors.neutral8};
    }
    & p {
        font-size: 16px;
        line-height: 24px;
        @media (max-width: 520px) {
            font-size: 14px;
            line-height: 20px;
        }
        color: ${colors.neutral6};
    }
    & label {
        font-size: 16px;
        color: ${colors.neutral6};
    }
    & ul {
        margin-top: 24px;
    }
    & a:last-child {
        @media (max-width: 520px) {
            margin-top: auto;
        }
    }
    margin-bottom: 24px;
}
`;

const Layout = ({ spacing, children }) => (
    <main css={containerStyle(spacing)}>{children}</main>
);

export default Layout;
